import { render } from "./ComponenteResultadoPeriodosTarifarios.vue?vue&type=template&id=621dbcc2&scoped=true"
import script from "./ComponenteResultadoPeriodosTarifarios.vue?vue&type=script&lang=js"
export * from "./ComponenteResultadoPeriodosTarifarios.vue?vue&type=script&lang=js"

import "./ComponenteResultadoPeriodosTarifarios.vue?vue&type=style&index=0&id=621dbcc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-621dbcc2"]])

export default __exports__